import { useEffect } from "react";
import PageMetaData from "../../Components/PageMetaData/PageMetaData";
import { useAppContext } from "../../Context/AppContext/AppContext";
import { getPageMetaData } from "../../Utils/meta-data";
import { useCurrentApplication } from "../../Context/CurrentApplicationContext/CurrentApplicationContext";
import ApplicationJourneySteps from "./components/ApplicationJourneySteps";
import ApplicationJourneyNotification from "./components/ApplicationJourneyNotification";
import ApplicationJourneyCTA from "./components/ApplicationJourneyCTA";
import ApplicationProcess from "./components/ApplicationProcess";
import WhatsAppConsentCard from "./components/WhatsAppConsentCard";
import JobPostDetails from "./components/JobPostDetails";
import AssessmentList from "./components/AssessmentList";
import Interview from "./components/Interview";
import { useAuth } from "../../Context/AuthContext/AuthContext";
import { useSearchParams } from "react-router-dom";
import { useJobApplicationActions } from "../../Hooks/useJobApplicationActions";
import "./index.scss";

const Requirements = () => {
  const { organization } = useAppContext();
  const { isUserLoggedIn } = useAuth();
  const { jobPost, currentView, isInitDone, jobApplication } =
    useCurrentApplication();

  const [searchParams, setSearchParams] = useSearchParams();
  const action = searchParams.get("action") || null;

  const { handleApply } = useJobApplicationActions();

  const meta = getPageMetaData("requirements", {
    organization: organization ? { orgName: organization.orgName } : undefined,
    jobTitle: jobPost?.title,
  });

  const getActiveViewContent = () => {
    switch (currentView) {
      case "apply":
        return <JobPostDetails />;

      case "profile-match":
        return <JobPostDetails />;

      case "assessment":
        return <AssessmentList />;

      case "interview":
        return <Interview />;

      case "result":
        return <JobPostDetails />;

      default:
        return <JobPostDetails />;
    }
  };

  useEffect(() => {
    if (
      isUserLoggedIn &&
      isInitDone &&
      jobPost &&
      !jobApplication &&
      action === "apply"
    ) {
      handleApply();
    }
  }, [isUserLoggedIn, jobPost, jobApplication, isInitDone, action]);

  if (!jobPost) {
    return null;
  }

  return (
    <>
      <PageMetaData title={meta.title} description={meta.description} />
      <div className="job-posts-details">
        <ApplicationJourneySteps />
        <div className="job-posts-details__grid">
          <div className="job-posts-details__main">
            <ApplicationJourneyNotification />
            {getActiveViewContent()}
          </div>

          <aside className="job-posts-details__sidebar">
            <ApplicationJourneyCTA />
            {currentView !== "assessment" && currentView !== "interview" && (
              <ApplicationProcess />
            )}
            <WhatsAppConsentCard />
          </aside>
        </div>
      </div>
    </>
  );
};

export default Requirements;
